import { useQuery } from '@apollo/client';
import {
  EnumGenericTaskType,
  FilterFindManyGenericTaskInput,
  QueryGenericTaskCountArgs
} from '@tools/ui/types/generated/graphql';
import { GenericTaskManyCount } from '../../../../queries/generic-task.query';

type IProps = {
  inboxType: EnumGenericTaskType;
  baseFilters?: FilterFindManyGenericTaskInput;
};

export const useTaskCount = ({
  baseFilters,
  inboxType
}: IProps): number | undefined => {
  const variables = {
    filter: {
      type: inboxType,
      ...baseFilters
    }
  };

  const { data } = useQuery<
    { genericTaskCount: number },
    QueryGenericTaskCountArgs
  >(GenericTaskManyCount, {
    variables,
    nextFetchPolicy: 'cache-first'
  });

  return data?.genericTaskCount;
};
